<script setup>
import { onMounted } from 'vue';
import Nav from './components/nav.vue';
import MasterSection from './components/MasterSection.vue';
import HallSection from './components/HallSection.vue';
import ServiceList from './components/ServiceList.vue';
import ServiceCaseSection from './components/ServiceCaseSection.vue';
import FeedbackSection from './components/FeedbackSection.vue';
import ContactSection from './components/ContactSection.vue';
import Footer from './components/Footer.vue';
import pcTopImg from '../../../assets/images/pc-top.png';
import { logEvent } from '@/utils/firebase.js';

onMounted(() => {
  // 页面浏览埋点
  logEvent('pc_fengsui_uv');
  logEvent('pc_fengsui_pv');
});
</script>

<template>
  <div class="pc-home">
    <Nav />
    <!-- PC端头图 -->
    <section class="hero-section">
      <img
        :src="pcTopImg"
        alt="楓燧堂服务介绍"
        class="hero-image"
      />
      <a
        href="https://diversion.salesmartly.com/split/whatsapp/fi8cxf"
        target="_blank"
        rel="noopener noreferrer"
        class="cta-button"
      >
        即刻獲取運勢分析
      </a>
    </section>

    <div class="content-wrapper">
      <!-- PC端内容 -->
      <div id="1">
        <MasterSection />
      </div>
      <HallSection />
      <div id="2">
        <ServiceList />
      </div>
      <div id="3">
        <FeedbackSection />
      </div>
      <div id="4">
        <ServiceCaseSection />
      </div>
      <div id="5">
        <ContactSection />
      </div>
    </div>
    <Footer />
  </div>
</template>

<style scoped lang="scss">
.pc-home {
  width: 100%;
}

.content-wrapper {
  padding: 0 100px;
}

.hero-section {
  position: relative;
  width: 100%;
  margin-top: 40px; // 导航栏高度
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.cta-button {
  position: absolute;
  bottom: 100px;
  left: 220px;
  //   transform: translateX(-50%);
  display: inline-block;
  padding: 5px 40px;
  background: #e5ae40;
  color: #000000;
  font-size: 8px;
  //   font-weight: 600;
  text-decoration: none;
  border-radius: 30px;
  //   box-shadow: 0 4px 15px rgba(229, 173, 62, 0.4);
  //   transition: all 0.3s ease;
  white-space: nowrap;
  z-index: 10;

  //   &:hover {
  //     background: linear-gradient(135deg, #d4af37 0%, #c49f2f 100%);
  //     box-shadow: 0 6px 20px rgba(229, 173, 62, 0.6);
  //     transform: translateX(-50%) translateY(-2px);
  //   }

  //   &:active {
  //     transform: translateX(-50%) translateY(0);
  //   }
}
</style>
